<div class="marketData-resultsNumber">{{ totalText }}</div>